import { createFileRoute } from '@tanstack/react-router'
import { CertificationEditor } from './-CertificationEditor'

export const Route = createFileRoute('/settings/certifications/$id')({
  component: EditCertificationPage,
})

function EditCertificationPage() {
  const { id } = Route.useParams()
  return <CertificationEditor id={id} />
}
